// import { CLICK_TYPE } from 'common/components/notification-component/notification-component';
import React, { Fragment } from 'react';

import { CLICK_TYPE } from 'featureLib/NotificationComponent';
import { FILE_MAX_SIZE } from 'common/constants/app.constants';

const MULTIPLE_SITE = 'MULTI_SITE';
const SINGLE_SITE = 'SINGLE_SITE';

/**
 * POST API RESOLVE PARAMS
 */
const VPN = 'VPN';
const DEDICATED_INTERNET = 'DEDICATED_INTERNET';
const FEASIBILITY = 'FEASIBILITY';
const ADDRESS_RESOLUTION = 'ADDRESS_RESOLUTION';
const INVALID_SITES_ADDRESS_RESOLUTION = 'INVALID_SITES_ADDRESS_RESOLUTION';
const INVALID_SITES_FEASIBILITY = 'INVALID_SITES_FEASIBILITY';
const BULK_UPGRADE_ACTIONS = {
  SAMPLE_CIRCUIT_INVENTORY: 'SAMPLE_CIRCUIT_INVENTORY',
  INVALID_CIRCUIT_INVENTORY: 'INVALID_CIRCUIT_INVENTORY',
  CONFIGURE_CIRCUIT_INVENTORY: 'CONFIGURE_CIRCUIT_INVENTORY',
  ORDER_LINE_ITEMS: 'ORDER_LINE_ITEMS'
};
const CART = 'CART';
const CREATED = 'CREATED';
const LOCATIONS_SAVED = 'LOCATIONS_SAVED';
const PLAN_CONFIGURATION_IN_PROGRESS = 'PLAN_CONFIGURATION_IN_PROGRESS';

const MULTI_SITE_MODULE_ID = 'B2B_ONLINE_ACQ_MULTI_SITE';
const AUTH_TOKEN = 'AUTH_TOKEN';
const LEAD_ID = 'LEAD_ID';
const CART_ID = 'CART_ID';
const CART_STATUS = 'CART_STATUS';
const FEASIBILITY_SUCCESS = 'FEASIBILITY_SUCCESS';
const ORDER_ID = 'ORDER_ID';
const SUMMARY_AUTH_TOKEN = 'SUMMARY_AUTH_TOKEN';
const MULTI_SITE_TABLE_EDITED = 'MULTI_SITE_TABLE_EDITED';
const SITE_READINESS_TABLE_EDITED = 'SITE_READINESS_TABLE_EDITED';
const RETRY_COUNT = 'RETRY_COUNT';
const AOI_TMO_REDIRECTED = 'AOI_TMO_REDIRECTED';

const SHORT_CB_DELAY = 2000;
const CALLBACK_DELAY = 5000;
const SUCCESS_TOAST = 'success';
const WARNING_TOAST = 'warning';
const ERROR_TOAST = 'error';
const ORDER_CONFIRMATION = 'order_confirmation';
const DEFAULT_TOAST_MSG = 'Something went wrong. Please try again...';
const KDM_TOAST_MSG = 'Live photo for KDM is mandatory';
const LINE_ITEM_FIELDS_PARAMS = {
  LOCATION_STATUS_MAP: 'LOCATION_STATUS_MAP',
  FEASIBILITY_STATUS_MAP: 'FEASIBILITY_STATUS_MAP',
  FEASIBILITY_MEDIA_MAP: 'FEASIBILITY_MEDIA_MAP',
  LINEITEM_STATUS_MAP: 'LINEITEM_STATUS_MAP'
};

const RADIO_OPTIONS = [
  { id: SINGLE_SITE, displayName: 'Single Site', orderType: ['UPGRADE', 'SHIFTING'], supportedProducts: ['DEDICATED_INTERNET', 'VPN'] },
  {
    id: MULTIPLE_SITE,
    displayName: 'Multiple Sites',
    orderType: ['NEW', 'UPGRADE', 'NEW_PRE_ORDER', 'UPGRADE_PRE_ORDER'],
    supportedProducts: ['DEDICATED_INTERNET', 'VPN', 'NLD', 'LL']
  }
];

const PAN_GST_RADIO_OPTIONS = [
  { id: 'gst', displayName: 'GSTIN' },
  {
    id: 'pan',
    displayName: 'PAN'
  }
];

const FILTER_TYPES = {
  INPUT: 'INPUT',
  AUTOCOMPLETE: 'AUTOCOMPLETE'
};

const ADDRESS_TYPE_ENUM = {
  EXISTINGADDRESS: 'existingAddress',
  NEWADDRESS: 'newAddress'
};

const addresses = [
  {
    id: ADDRESS_TYPE_ENUM.EXISTINGADDRESS,
    displayName: 'Existing Addresses',
    disabled: true
  },
  { id: ADDRESS_TYPE_ENUM.NEWADDRESS, displayName: 'New Address' }
];

const DOCUMENT_TYPE_ENUM = {
  SEZ: 'SEZ',
  PURCHASE_ORDER: 'PURCHASE_ORDER',
  AUTHORIZED_SIGNATORY: 'AUTHORIZED_SIGNATORY',
  LOI: 'LOI'
  // AADHAAR: 'AADHAAR',
  // VOTER_CARD: 'VOTER_CARD',
  // DRIVING_LICENSE : 'DRIVING_LICENSE',
  // PAN_CARD : 'PAN_CARD'
};

const formElement = { value: null, errors: [], touched: false };

const optionsForExistingAddress = [
  { displayName: 'Same as Billing address', key: 'billingAddress' },
  { displayName: 'Same as Installation address', key: 'installationAddress' }
];

const fileSchemaForGSTCertificate = {
  supportedTypes: ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'],
  maxFileLimit: FILE_MAX_SIZE,
  documentNames: ['GST_CERTIFICATE'],
  documentType: DOCUMENT_TYPE_ENUM.SEZ
};
const fileSchemaForGSTLOA = {
  supportedTypes: ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'],
  maxFileLimit: FILE_MAX_SIZE,
  documentNames: ['GST_LOA_1', 'GST_LOA_2', 'GST_LOA_3'],
  documentType: DOCUMENT_TYPE_ENUM.SEZ
};

const PLAN_CONFIGURATION = {
  SUBMITTED: 'PLAN_CONFIGURATION_SUBMITTED',
  PROGRESS: 'PLAN_CONFIGURATION_IN_PROGRESS',
  SAVED: 'PLAN_CONFIGURATION_SAVED',
  PNQ_IN_PROGRESS: 'PNQ_IN_PROGRESS',
  PNQ_COMPLETED: 'PNQ_COMPLETED',
  PNQ_CANCELED: 'PNQ_CANCELED',
  SEND_TO_DOA: 'SEND_TO_DOA',
  PRICING_DOA_APPROVED: 'PRICING_DOA_APPROVED',
  PRICING_DOA_REJECTED: 'PRICING_DOA_REJECTED'
};

const ORDER_STAGE = {
  KYC_INPROGRESS: 'KYC_INPROGRESS',
  CART_CANCELLED: 'CART_CANCELLED',
  ORDER_CANCELED: 'ORDER_CANCELED',
  KYC_COMPLETED: 'KYC_COMPLETED'
};

const CART_STAGE = {
  CREATED: 'CREATED',
  LOCATIONS_SAVED: 'LOCATIONS_SAVED'
};

const FILE_UPLOAD_PAGES = {
  SAMPLE_DOWNLOAD: 'SAMPLE_DOWNLOAD',
  ADDRESS_RESOLUTION: 'ADDRESS_RESOLUTION',
  CART_FEASIBILITY: 'CART_FEASIBILITY',
  ORDER_SUMMARY: 'ORDER_SUMMARY',
  SITE_READINESS: 'SITE_READINESS'
};

const TABLE_RENDERER = {
  ADDRESS_TABLE: 'ADDRESS_TABLE',
  FEASIBILITY_TABLE: 'FEASIBILITY_TABLE',
  CART_TABLE: 'CART_TABLE',
  ORDER_TABLE: 'ORDER_TABLE'
};

const NOTIFICATION_ACTION = {
  EDIT_WITH_EXCEL: 'editWithExcel',
  PROCEED: 'proceed',
  DOWNLOAD_EXCEL: 'downloadExcel',
  VIEW_MORE: 'viewMore',
  ORDER_CONFIRMATION: 'orderConfirmation'
};

const PROCEED_ELEMENT = (
  <a type="link" href="javascript:void(0);" role="button" tabindex="0">
    <strong id="link" data-type={CLICK_TYPE.LINK} data-name={NOTIFICATION_ACTION.PROCEED} data-action={NOTIFICATION_ACTION.PROCEED}>
      "Proceed"
    </strong>
  </a>
);
const EDIT_WITH_EXCEL = (
  <a type="link" href="javascript:void(0);" role="button" tabindex="0">
    <strong id="link" data-type={CLICK_TYPE.LINK} data-name={NOTIFICATION_ACTION.EDIT_WITH_EXCEL} data-action={NOTIFICATION_ACTION.EDIT_WITH_EXCEL}>
      "Edit With Excel"
    </strong>
  </a>
);
const NOTIFICATION_MESSAGE = {
  ALL_PROCESSED: (
    <span>
      <strong>addresses are successfully processed</strong> on the system. You may {PROCEED_ELEMENT} to the feasibility result.
    </span>
  ),
  INCOMPLETE_ADDRESS: (
    <span>
      {' '}
      <strong>addresses have incomplete address </strong> resolution status. For accurate feasibility please update the address by clicking on {EDIT_WITH_EXCEL} . You may also{' '}
      {PROCEED_ELEMENT} with the order without editing.{' '}
    </span>
  ),
  MANUAL_INTERVENTION_REQUIRED: (
    <Fragment>
      <strong> sites require Manual Network Feasibility Check.</strong>{' '}
      <p>Our team will contact you within 24hrs for the network check. You may also {PROCEED_ELEMENT} with the order for the feasible sites.</p>{' '}
    </Fragment>
  ),
  COMPANY_AGREED_RATES: 'Company-agreed rates are displayed below',
  UPLOAD_EXCEL_FEASIBILTY: (
    <div className="download_info">
      Add up to 500 locations with details like Company name, Installation address, and Pincode with help of the sample excel document.
      <br />
      <p className="smaple_doc">
        {' '}
        <span className="sample_docs_name" data-type={CLICK_TYPE.LINK} data-name={NOTIFICATION_ACTION.DOWNLOAD_EXCEL} data-action={NOTIFICATION_ACTION.DOWNLOAD_EXCEL}>
          Download Sample.xlsx
        </span>{' '}
        <span className="material-icons">download</span>
      </p>
    </div>
  ),
  ORDER_REJECTED_BEACUSE: (
    <span>
      {' '}
      <strong>Your order has been rejected</strong>. Kindly resubmit the order after updating the details according to the rejection reason(s). Following are the reason(s) for
      rejection :{' '}
    </span>
  ),
  CONFIRM_ORDER: (
    <a
      className="underline"
      href="javascript:void(0)"
      data-type={CLICK_TYPE.LINK}
      data-name={NOTIFICATION_ACTION.ORDER_CONFIRMATION}
      data-action={NOTIFICATION_ACTION.ORDER_CONFIRMATION}
    >
      Confirm Order.
    </a>
  )
};

const TOOLTIP_MESSAGE = {
  EDIT_WITH_EXCEL: 'Edit or delete location details via Excel.',
  DOWNLOAD_FEASIBILTY_REPORT: 'Click to download the detailed feasibility result',
  EMAIL_PRICING_PROPOSAL: 'Click to send the Pricing Quotations to your email.',
  CONFIGURE_SITE_WITH_EXCEL: 'Click on "Configure Sites with Excel" to change the configurations like (Managed/Unmanaged, Router details, IP attributes, etc).',
  VIEW_AVAILABLE_CONFIGURATION: 'Click to view the available configurations.',
  NEED_ASSISTANCE: 'Click to contact your Key Account Manager for assistance.',
  BCP_ID: 'Enter a BCP ID to autofill all the related details. Click here to view the list of all the BCP IDs.'
};

const FEASIBILITY_LOCATION_STATUS = {
  INVALID_ADDRESS: 'INVALID_ADDRESS',
  ADDRESS_INCOMPLETE: 'ADDRESS_INCOMPLETE',
  ADDRESS_COMPLETE: 'ADDRESS_COMPLETE',
  RESOLVED: 'RESOLVED',
  UNRESOLVED: 'UNRESOLVED',
  INCORRECT_DETAILS: 'INCORRECT_DETAILS',
  NEARBY_LOCATIONS: 'NEARBY_LOCATIONS'
};

const FEASIBILITY_MESSAGE = {
  INVALID_ADDRESS_NLD: 'Distance between installation address point A and B should be equal/more than 45 kms.',
  INVALID_ADDRESS_LL: 'Distance between installation address point A and B should be less than 45 kms.'
};

const SERVICE_TYPE = {
  MANAGED: {
    id: 'MANAGED',
    displayName: 'Managed'
  },
  UNMANAGED: {
    id: 'UNMANAGED',
    displayName: 'Unmanaged'
  },
  PARTIALLY_MANAGED: {
    id: 'PARTIALLY_MANAGED',
    displayName: 'Partially Managed'
  }
};

const SERVICE_TYPE_LIST = [
  { id: SERVICE_TYPE.MANAGED.id, displayName: SERVICE_TYPE.MANAGED.displayName },
  { id: SERVICE_TYPE.PARTIALLY_MANAGED.id, displayName: SERVICE_TYPE.PARTIALLY_MANAGED.displayName },
  { id: SERVICE_TYPE.UNMANAGED.id, displayName: SERVICE_TYPE.UNMANAGED.displayName }
];

const HARDWARE_TYPE = {
  STANDARD: 'Standard',
  NON_STANDARD: 'Non Standard'
};

export {
  KDM_TOAST_MSG,
  MULTIPLE_SITE,
  SINGLE_SITE,
  RADIO_OPTIONS,
  VPN,
  DEDICATED_INTERNET,
  FEASIBILITY,
  ADDRESS_RESOLUTION,
  FILTER_TYPES,
  CART,
  CREATED,
  LOCATIONS_SAVED,
  PLAN_CONFIGURATION_IN_PROGRESS,
  MULTI_SITE_MODULE_ID,
  LINE_ITEM_FIELDS_PARAMS,
  MULTI_SITE_TABLE_EDITED,
  SITE_READINESS_TABLE_EDITED,
  AUTH_TOKEN,
  RETRY_COUNT,
  LEAD_ID,
  CART_ID,
  CART_STATUS,
  FEASIBILITY_SUCCESS,
  ORDER_ID,
  SUMMARY_AUTH_TOKEN,
  SHORT_CB_DELAY,
  CALLBACK_DELAY,
  SUCCESS_TOAST,
  WARNING_TOAST,
  ORDER_CONFIRMATION,
  ERROR_TOAST,
  DEFAULT_TOAST_MSG,
  ADDRESS_TYPE_ENUM,
  addresses,
  DOCUMENT_TYPE_ENUM,
  formElement,
  optionsForExistingAddress,
  fileSchemaForGSTCertificate,
  fileSchemaForGSTLOA,
  PLAN_CONFIGURATION,
  FILE_UPLOAD_PAGES,
  TABLE_RENDERER,
  TOOLTIP_MESSAGE,
  NOTIFICATION_MESSAGE,
  NOTIFICATION_ACTION,
  ORDER_STAGE,
  CART_STAGE,
  FEASIBILITY_MESSAGE,
  FEASIBILITY_LOCATION_STATUS,
  BULK_UPGRADE_ACTIONS,
  SERVICE_TYPE,
  SERVICE_TYPE_LIST,
  HARDWARE_TYPE,
  INVALID_SITES_ADDRESS_RESOLUTION,
  INVALID_SITES_FEASIBILITY,
  PAN_GST_RADIO_OPTIONS,
  AOI_TMO_REDIRECTED
};
